var _SpriteSymbol = require("/runner/_work/CertifyApp/CertifyApp/node_modules/rspack-plugin-svg-sprite/dist/runtime/symbol");
var SpriteSymbol = _SpriteSymbol.default || _SpriteSymbol;
var symbol = new SpriteSymbol({"id":"done-gray","viewBox":"0 0 24 24","content":"<symbol id=\"done-gray\" viewBox=\"0 0 24 24\" fill=\"gray\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z\"/></symbol>"});
symbol.url = "/Scripts/dist/sprite.svg#done-gray";
export default symbol;
